import { Menu, MenuItem, SubMenu } from '@/components/atoms';
import { Space } from 'antd';
import { Link } from 'react-router-dom';

type ServiceMenuProps = {
  path: string;
};

const ManageMenu = ({ path }: ServiceMenuProps) => {
  const [root, first, second] = path.split('/');
  return (
    <Menu mode="inline" defaultOpenKeys={[`/${first}/${second}`]} defaultSelectedKeys={[path]}>
      <SubMenu key="/manage/user" title={<Space direction="horizontal">사용자 정보</Space>}>
        <MenuItem key="/manage/user/info">
          <Link to="/manage/user/info">사용자</Link>
        </MenuItem>
      </SubMenu>
      <SubMenu
        key="/manage/solution"
        title={
          <Space direction="horizontal">
            {/* <img src={iconPaper} alt="업무관리 아이콘" /> */}
            핀카 제품
          </Space>
        }
      >
        <MenuItem key="/manage/solution">
          <Link to="/manage/solution">제품정보</Link>
        </MenuItem>
      </SubMenu>
      <SubMenu
        key="/manage/usage"
        title={
          <Space direction="horizontal">
            {/* <img src={iconPaper} alt="업무관리 아이콘" /> */}
            청구 정보
          </Space>
        }
      >
        <MenuItem key="/manage/bill/list">
          <Link to="/manage/bill/list">청구내역</Link>
        </MenuItem>
        <MenuItem key="/manage/usage/history">
          <Link to="/manage/usage/history">이용내역</Link>
        </MenuItem>
      </SubMenu>
      <SubMenu
        key="/manage/company"
        title={
          <Space direction="horizontal">
            {/* <img src={iconPaper} alt="업무관리 아이콘" /> */}
            가입 정보
          </Space>
        }
      >
        <MenuItem key="/manage/company/info">
          <Link to="/manage/company/info">사업자 정보</Link>
        </MenuItem>
      </SubMenu>
    </Menu>
  );
};

export default ManageMenu;
